import types from '../types';
import api from 'api';
import {
   DiplomatServiceProperties,
   IDiplomatServiceProperties,
} from 'types/DiplomatServiceProperties';
import {useGetApiDispatch} from 'common/hooks/useGetApiDispatch';

export const useServiceProperties = () =>
   useGetApiDispatch<IDiplomatServiceProperties>(
      DiplomatServiceProperties.cast({}),
      api.serverServiceProperties,
      types.GET_SERVICE_PROPERTIES
   );
